import { IMG } from "@/lib/content";
import { Reveal, MaskedLines } from "@/components/motion/Reveal";
import { Parallax } from "@/components/motion/Parallax";

export function Positioning() {
  return (
    <section className="bg-paper py-28 md:py-44" aria-labelledby="positioning-title">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-8">
          <Reveal className="lg:col-span-2">
            <p className="label text-mute flex items-center gap-4"><span className="w-6 h-px bg-ink/40" /> 02 · Haltung</p>
          </Reveal>
          <div className="lg:col-span-10">
            <MaskedLines
              as="h2"
              id="positioning-title"
              lines={["Sauberkeit ist kein Detail.", "Sie ist der erste Eindruck."]}
              className="display text-4xl sm:text-5xl lg:text-6xl xl:text-[5.2rem] text-ink max-w-[16ch]"
            />
            <Reveal delay={0.3} className="mt-12 md:mt-16 lg:ml-[33%] max-w-xl">
              <p className="text-base md:text-lg text-mute leading-relaxed">
                Ob Wohnung, Büro, Liegenschaft oder Gewerbefläche: Emini Reinigung sorgt für gepflegte Räume, verlässliche Abläufe und eine Ausführung, auf die Sie sich verlassen können.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
      <Reveal className="mt-24 md:mt-32 container-x" y={0}>
        <Parallax src={IMG.positioning} alt="Ruhiges Wohninterieur in warmen Naturtönen" className="aspect-[4/3] md:aspect-[21/9]" amount={10}>
          <div className="absolute bottom-0 left-0 label text-paper/80 bg-ink/40 backdrop-blur-md px-5 py-4">Wohnen · Deutschschweiz</div>
        </Parallax>
      </Reveal>
    </section>
  );
}
